import { takeLatest, put, call, all, fork } from "redux-saga/effects";
import {
  getCrossSellAPI,
  getCityAPI,
  exportCrossSellReportAPI,
} from "./api";
import {
  getCrossSellSuccess,
  getCrossSellFailure,
  getCitySuccess,
  getCityFailure,
  exportCrossSellReportSuccess,
  exportCrossSellReportFailed,
} from "./action";
import {
  GET_CROSSSELL_START,
  GET_CITY_START,
  EXPORT_CROSS_SELL_REPORT,
} from "./actiontypes";

function* getCrossSellAsync(action) {
  try {
    const response = yield call(getCrossSellAPI, action.payload || {});
    // success when HTTP 200
    if (response && response.status === 200) {
      // response.data should hold { cust_list, pagination }
      yield put(getCrossSellSuccess(response.data));
    } else {
      yield put(getCrossSellFailure({ message: "Failed to fetch cross-sell data" }));
    }
  } catch (error) {
    // Be defensive: check shape of error
    const payload = (error && error.response && error.response.data) ? error.response.data : { message: error.message || "Unknown error" };
    yield put(getCrossSellFailure(payload));
  }
}

function* watchGetCrossSell() {
  yield takeLatest(GET_CROSSSELL_START, getCrossSellAsync);
}

function* getCityAsync() {
  try {
    const response = yield call(getCityAPI);
    if (response && response.status === 200) {
      yield put(getCitySuccess(response.data));
    } else {
      yield put(getCityFailure({ message: "Failed to fetch cities" }));
    }
  } catch (error) {
    const payload = (error && error.response && error.response.data) ? error.response.data : { message: error.message || "Unknown error" };
    yield put(getCityFailure(payload));
  }
}

function* watchGetCity() {
  yield takeLatest(GET_CITY_START, getCityAsync);
}

function* exportExcelReportAsync(action) {
  try {
    const response = yield call(exportCrossSellReportAPI, action.payload || {});
    if (response && response.status === 200) {
      // assume API returns { cust_list: [...] }
      yield put(exportCrossSellReportSuccess(response.data?.cust_list || []));
    } else {
      yield put(exportCrossSellReportFailed({ message: "Failed to export report" }));
    }
  } catch (error) {
    const payload = (error && error.response && error.response.data) ? error.response.data : { message: error.message || "Unknown error" };
    yield put(exportCrossSellReportFailed(payload));
  }
}

function* watchExportCrossSellReport() {
  yield takeLatest(EXPORT_CROSS_SELL_REPORT, exportExcelReportAsync);
}

export default function* CrossSellSaga() {
  yield all([fork(watchGetCrossSell), fork(watchGetCity), fork(watchExportCrossSellReport)]);
}
